// dev
export const environment = {
    apiUrl: 'http://52.172.145.122:1101/user/api/v1/auth',
    apiUrluser: 'http://52.172.145.122:1101/user/api/v1',
    masterapiurl: 'http://52.172.145.122:1101/MasterApi/v1',
    imagepath: 'http://52.172.145.122/uploads',
    wcdurl: 'https://missionshakti.wcd.gov.in/api/auth',
    wcdApiUrl: 'https://wcd.gov.in/api',
    captchaEnabled: false,


    // apiUrl : 'https://pankhudi.wcd.gov.in/API/user/api/v1/auth',
    // apiUrluser : 'https://pankhudi.wcd.gov.in/API/user/api/v1',
    // masterapiurl :'https://pankhudi.wcd.gov.in/API/MasterApi/v1',
    // imagepath : 'https://pankhudi.wcd.gov.in/uploads/',
    // wcdurl :'https://missionshakti.wcd.gov.in/api/auth',
};
